import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Award, Clock, MapPin } from 'lucide-react';
import { businessData } from '../mock';

const Home = () => {
  return (
    <div className="page-home">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-overlay"></div>
        <img
          src={businessData.images.hero}
          alt="Herrefrisør interiør"
          className="hero-image"
        />
        <div className="hero-content">
          <h1 className="hero-title">Herrefrisør</h1>
          <p className="hero-subtitle">Over 50 års erfaring på Nørrebro</p>
          <p className="hero-description">
            Klassisk herreklip uden hastværk.
            Autentisk håndværk i hjertet af København.
          </p>
          <a href={`tel:${businessData.phone}`} className="hero-cta">
            <Phone size={20} />
            Ring for tid
          </a>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <div className="features-container">
          <div className="feature-card">
            <div className="feature-icon">
              <Award size={32} />
            </div>
            <h3 className="feature-title">Over 50 års erfaring</h3>
            <p className="feature-text">
              Klassisk håndværk og professionel service siden 1970'erne
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">
              <Clock size={32} />
            </div>
            <h3 className="feature-title">Tid til kvalitet</h3>
            <p className="feature-text">
              Ingen hastværk – hver kunde får den tid og opmærksomhed, de fortjener
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">
              <MapPin size={32} />
            </div>
            <h3 className="feature-title">Ægte Nørrebro</h3>
            <p className="feature-text">
              En lokal institution med autentisk stemning og bramfri atmosfære
            </p>
          </div>
        </div>
      </section>

      {/* About Preview */}
      <section className="about-preview-section">
        <div className="about-preview-grid">
          <div className="about-preview-image-wrapper">
            <img
              src={businessData.images.about}
              alt="Klassisk barbering"
              className="about-preview-image"
            />
          </div>
          <div className="about-preview-content">
            <h2 className="section-title">En af de sidste af sin slags</h2>
            <p className="section-text">
              Herrefrisør er ikke bare en frisørsalon – det er en oplevelse.
              Med over 50 års erfaring tilbyder vi klassisk herreklip i autentiske
              omgivelser med brun træindretning, dagens avis og en rolig atmosfære.
            </p>
            <p className="section-text">
              Her er der ingen online booking eller moderne hype. Bare kvalitet,
              tradition og personlig service i hver eneste klipning.
            </p>
            <Link to="/om" className="text-link">
              Læs mere om os →
            </Link>
          </div>
        </div>
      </section>

      {/* Services Preview */}
      <section className="services-preview-section">
        <div className="services-preview-container">
          <div className="services-preview-content">
            <h2 className="section-title">Klassisk herreklip</h2>
            <p className="section-text">
              Vi holder det enkelt og autentisk. Et professionelt herreklip
              udført med omhu, erfaring og respekt for håndværket.
            </p>
            <div className="price-display">
              <span className="price-label">Herreklip</span>
              <span className="price-amount">ca. 170 kr.</span>
            </div>
            <Link to="/priser" className="text-link">
              Se alle priser →
            </Link>
          </div>
          <div className="services-preview-image-wrapper">
            <img
              src={businessData.images.service}
              alt="Herreklip"
              className="services-preview-image"
            />
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-container">
          <h2 className="cta-title">Klar til en klassisk klipning?</h2>
          <p className="cta-text">
            Ring til os for at booke en tid. Vi glæder os til at se dig.
          </p>
          <a href={`tel:${businessData.phone}`} className="cta-button">
            <Phone size={20} />
            {businessData.phone}
          </a>
        </div>
      </section>
    </div>
  );
};

export default Home;